import * as types from '@/store/mutaionType'
import * as langMd from '@/i18n'

const state = {
    lang: 'en',
    storeStr:'google.com',
    cards:[
    ]
}

const getters = {
    curLang: state => {
      return state.lang
    }
}

const mutations = {
    [types.SET_LANG] (state, lang) {
      state.lang = lang
    },
    [types.SET_CUR_MSG] (state, msg) {
      state.curMessage = msg
    }
}

const actions = {
    setLang ({commit, state}, lang) {
      state.lang = lang
      commit(types.SET_LANG, lang)
      langMd.setLang(lang)
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}